<template>
    <div class="homeView container mt-4">
        <h1>Welcome</h1>
        <p>Unauthorised access is prohibited and may constitute an offence under the computer misue act 1990 (as
            amended).</p>
        <p><b>For security, all access is recorded.</b></p>
    </div>
</template>
